<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-09 16:21:32
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-09 16:37:12
 * @name: 普通容器
 * @Description: 普通容器,带标头,简单展示内容
 * @FilePath: \backstage\src\components\public\container-normal.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="containerNormal">
    <div class="head">
      <font>{{title}}</font>
    </div>
    <slot name="containerNormal"/>
  </div>
</template>
<script>
export default {
  name: "containerNormal",
  props: {
    title: {
      type: String,
      default: '',
    }
  }
};
</script>
<style lang="scss" scoped>
.containerNormal {
  border-radius: $Vars-border-radius-normal;
  border: 1px solid $Vars-info-color;
  .head {
    width: 100%;
    height: 30px;
    @extend .extend-flex-center;
    border-bottom: 1px solid $Vars-info-color;
  }
}
</style>
